// created from 'create-ts-index'

export * from './metric-user.model';
